import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ProgressLoader from 'components/essentials/ProgressLoader/ProgressLoader';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import LivestreamPageUI from './LivestreamPageUI';
import { getVideoEntries, videoCategoryList } from './utils';
const LivestreamPage = t0 => {
  const $ = _c(15);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isAdmin: t2
  } = t1;
  const isAdmin = t2 === undefined ? false : t2;
  const [page, updatePage] = useState(0);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [videos, updateVideos] = useState(t3);
  const [hasMoreVideos, updateHasMoreVideos] = useState(true);
  let t4;
  let t5;
  if ($[3] !== page) {
    t4 = () => {
      getVideoEntries({
        params: {
          limit: 20,
          skip: page ? page * 20 : 0
        }
      }).then(videoList => {
        const newVideos = videoList ?? [];
        if (newVideos.length > 0) {
          updateVideos(prevVideos => [...prevVideos, ...newVideos]);
          updateHasMoreVideos(true);
        } else {
          updateHasMoreVideos(false);
        }
      }).catch(_temp);
    };
    t5 = [page];
    $[3] = page;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  if (isAdmin) {
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <FixedWidthContainer className="text-center">Place holder for videos blog.</FixedWidthContainer>;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    return t6;
  }
  let t6;
  if ($[7] !== page) {
    t6 = () => {
      updatePage(page + 1);
    };
    $[7] = page;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const loadMoreVideos = t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = videoCategoryList();
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const videoCategories = t7;
  let t8;
  if ($[10] !== hasMoreVideos || $[11] !== isAdmin || $[12] !== loadMoreVideos || $[13] !== videos) {
    t8 = videos.length > 0 ? <LivestreamPageUI videos={videos} videoCategories={videoCategories} isAdmin={isAdmin} videoStreamingLive={null} loadMoreVideos={loadMoreVideos} hasMoreVideos={hasMoreVideos} /> : <ProgressLoader />;
    $[10] = hasMoreVideos;
    $[11] = isAdmin;
    $[12] = loadMoreVideos;
    $[13] = videos;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
LivestreamPage.propTypes = {
  isAdmin: PropTypes.bool
};
export default LivestreamPage;
function _temp(e) {
  return e;
}